import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent) },
  { path: 'variables', loadComponent: () => import('./pages/variables/variables.component').then((m) => m.VariablesComponent) },
  { path: 'variables/colors', loadComponent: () => import('./pages/variables/colors/colors.component').then((m) => m.ColorsComponent) },
  { path: 'variables/typography', loadComponent: () => import('./pages/variables/typography/typography.component').then((m) => m.TypographyComponent) },
  { path: 'variables/spacing', loadComponent: () => import('./pages/variables/spacing/spacing.component').then((m) => m.SpacingComponent) },
  { path: 'variables/shadows', loadComponent: () => import('./pages/variables/shadows/shadows.component').then((m) => m.ShadowsComponent) },
  { path: 'variables/corner-radius', loadComponent: () => import('./pages/variables/corner-radius/corner-radius.component').then((m) => m.CornerRadiusComponent) },
  { path: 'components', loadComponent: () => import('./pages/components/components.component').then((m) => m.ComponentsComponent) },
  { path: 'components/buttons', loadComponent: () => import('./pages/components/buttons/buttons.component').then((m) => m.ButtonsComponent) },
  { path: 'components/icons', loadComponent: () => import('./pages/components/icons/icons.component').then((m) => m.IconsComponent) },
  { path: 'components/top-bar', loadComponent: () => import('./pages/components/top-bar/top-bar.component').then((m) => m.TopBarComponent) },
  { path: 'components/avatars', loadComponent: () => import('./pages/components/avatars/avatars.component').then((m) => m.AvatarsComponent) },
  { path: 'components/pills', loadComponent: () => import('./pages/components/pills/pills.component').then((m) => m.PillsComponent) },
  { path: 'components/navigation', redirectTo: 'components/navigation/desktop', pathMatch: 'full' },
  {
    path: 'components/navigation/desktop',
    loadComponent: () =>
      import('./pages/components/navigation/desktop/desktop-navigation-page.component').then(
        (m) => m.DesktopNavigationPageComponent,
      ),
  },
  {
    path: 'components/navigation/mobile',
    loadComponent: () =>
      import('./pages/components/navigation/mobile/mobile-navigation-page.component').then(
        (m) => m.MobileNavigationPageComponent,
      ),
  },
  { path: '**', redirectTo: 'home' },
];
